/**
 * FAQ data for the FaqSection component and the JSON-LD FAQPage schema.
 * Keeping data here means the schema in index.html stays in sync with
 * what the component actually renders.
 */
export const FAQ_ITEMS = [
  {
    id: 'faq-sicherheit',
    question: 'Ist Binance seriös und sicher?',
    answer:
      'Ja. Binance ist die weltgrößte Kryptobörse nach Handelsvolumen mit über 185 Millionen Nutzern weltweit. Die Plattform setzt auf Zwei-Faktor-Authentifizierung (2FA), Cold Storage für 95 % aller Kundengelder und den SAFU-Fonds (Secure Asset Fund for Users) – ein Milliardenreserve-Fonds, der im Notfall Kundenvermögen absichert.',
  },
  {
    id: 'faq-kosten',
    question: 'Wie viel kostet es, Bitcoin auf Binance zu kaufen?',
    answer:
      'Binance berechnet eine Standardgebühr von 0,10 % pro Transaktion – eine der niedrigsten in der Branche. Mit unserem exklusiven Affiliate-Link sparst du dauerhaft 10 % auf alle Handelsgebühren (nur noch 0,09 %). SEPA-Einzahlungen sind vollständig kostenlos. Kreditkartenkäufe kosten ca. 1,8 % Aufschlag.',
  },
  {
    id: 'faq-minimum',
    question: 'Kann ich mit 10 € Bitcoin kaufen?',
    answer:
      'Ja, du kannst sogar mit weniger als 10 € starten. Bitcoin ist in sogenannte Satoshi unterteilt: 1 BTC = 100.000.000 Satoshi. Das bedeutet: Du kaufst immer einen Bruchteil eines Bitcoins – und das ist vollkommen normal. Schon mit 10 € wirst du Bitcoin-Besitzer.',
  },
  {
    id: 'faq-kyc-erklaerung',
    question: 'Was ist die KYC-Verifizierung und warum ist sie nötig?',
    answer:
      'KYC steht für „Know Your Customer" (Kenne deinen Kunden). Es ist eine gesetzlich verpflichtende Identitätsprüfung, die alle regulierten Finanzplattformen – auch Kryptobörsen – durchführen müssen. Sie schützt vor Geldwäsche und Betrug. Du benötigst lediglich einen gültigen Personalausweis oder Reisepass sowie ein Selfie.',
  },
  {
    id: 'faq-kyc-dauer',
    question: 'Wie lange dauert die Verifizierung auf Binance?',
    answer:
      'Die automatische KI-gestützte Gesichtserkennung dauert in der Regel unter 10 Minuten. In Ausnahmefällen wird dein Antrag manuell geprüft – das kann bis zu 24 Stunden dauern. Du wirst per E-Mail benachrichtigt, sobald dein Konto freigeschaltet ist.',
  },
  {
    id: 'faq-sepa-dauer',
    question: 'Wie lange dauert eine SEPA-Überweisung bei Binance?',
    answer:
      'SEPA-Überweisungen dauern in der Regel 1–2 Werktage. Wenn du sofort kaufen möchtest, empfiehlt sich die Kreditkartenzahlung – das Guthaben ist innerhalb weniger Minuten verfügbar (Aufschlag ca. 1,8 %).',
  },
];
